let deferredInstallPrompt = null;
let initialized = false;

const notify = () => {
  window.dispatchEvent(new Event("bikeparks-install-state-change"));
};

export const initializePwaInstall = () => {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
    notify();
  });

  window.addEventListener("appinstalled", () => {
    deferredInstallPrompt = null;
    notify();
  });
};

export const canPromptForPwaInstall = () => Boolean(deferredInstallPrompt);

export const promptForPwaInstall = async () => {
  if (!deferredInstallPrompt) return null;

  const prompt = deferredInstallPrompt;
  deferredInstallPrompt = null;
  notify();

  await prompt.prompt();
  const choice = await prompt.userChoice;
  return choice?.outcome || null;
};
